import { __decorate } from "tslib";
import { SVG_CLOSE } from '@getgo/chameleon-icons';
import { customElement, html, when } from '@microsoft/fast-element';
import { AlertBase, DEFAULT_CLOSE_ARIA_LABEL } from '../common/AlertBase';
import styles from './Alert.styles.scss';
const template = html `
  <template role="alert" variant="${(x) => { var _a; return (_a = x.variant) !== null && _a !== void 0 ? _a : 'info'; }}">
    <slot name="icon"></slot>
    <div class="alert-content">
      <slot></slot>
      <slot name="action"></slot>
    </div>
    ${when((x) => x.closable, html `<chameleon-icon-button
        size="small"
        variant="secondary"
        aria-label="${(x) => { var _a; return (_a = x.closeLabel) !== null && _a !== void 0 ? _a : DEFAULT_CLOSE_ARIA_LABEL; }}"
        @click=${(x) => x.close()}
      >
        <chameleon-svg>${SVG_CLOSE}</chameleon-svg>
      </chameleon-icon-button>`)}
  </template>
`;
export const alertDefinition = { name: 'chameleon-alert', template, styles };
let AlertComponent = class AlertComponent extends AlertBase {
};
AlertComponent = __decorate([
    customElement(alertDefinition)
], AlertComponent);
export { AlertComponent };
